module.exports = __webpack_public_path__ + "img/sabaz.b9391503.png";